
















































import { defineComponent } from '@vue/composition-api';
import OlbImage from '../../image';
import OlbButton from '../../button';

export default defineComponent({
	components: {
		OlbImage,
		OlbButton,
	},
	props: {
		url: {
			type: String,
		},
		image: {
			type: String,
		},
		imageAlt: {
			type: String,
		},
		keyword: {
			type: String,
		},
		zip: {
			type: String,
		},
		location: {
			type: String,
		},
		livingSpace: {
			type: String,
		},
		landArea: {
			type: String,
		},
		price: {
			type: String,
		},
		referenceNumber: {
			type: String,
		},
		locationLabel: {
			type: String,
		},
		livingSpaceLabel: {
			type: String,
		},
		landAreaLabel: {
			type: String,
		},
		priceLabel: {
			type: String,
		},
		refLabel: {
			type: String,
		},
		detailbutton: {
			type: String,
		},
	},
});
